export const SUBMIT_CONSENT_FORM_INITIAL_DATA_START = 'SUBMIT_CONSENT_FORM_INITIAL_DATA_START';
export const SUBMIT_CONSENT_FORM_INITIAL_DATA_FAIL = 'SUBMIT_CONSENT_FORM_INITIAL_DATA_FAIL';
export const SUBMIT_CONSENT_FORM_INITIAL_DATA_SUCCESS = 'SUBMIT_CONSENT_FORM_INITIAL_DATA_SUCCESS';

export const SUBMIT_CONSENT_FORM_CONFIRMATION_START = 'SUBMIT_CONSENT_FORM_CONFIRMATION_START';
export const SUBMIT_CONSENT_FORM_CONFIRMATION_FAIL = 'SUBMIT_CONSENT_FORM_CONFIRMATION_FAIL';
export const SUBMIT_CONSENT_FORM_CONFIRMATION_SUCCESS = 'SUBMIT_CONSENT_FORM_CONFIRMATION_SUCCESS';

export const INCREMENT_CONSENT_FORM_INDEX = 'INCREMENT_CONSENT_FORM_INDEX';